export default [
  {
    path: '/debate-vote/:id',
    name: 'index',
    component: () => import('@/views/debate-vote/index'),
    meta: {
      title: '辩论型投票',
      content:'学海无涯，来抽上岸盲盒！更有时间管理器+惊喜礼盒轻松拿，马上报名行动派>>'
    }
  }
]
